import { Media } from "types/qbank/media";
import { MimeTypeClassifications } from "types/qbank/mimeTypeClassifications";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { IMAGE_STATE } from "types/imageState";
import { useApi } from "hooks/api";
import { useSessionDetails } from "hooks/sessionDetails";
import { useMutation } from "react-query";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { IconButton, SxProps, Theme } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { useSnackbar } from "notistack";

export default function CopyLinkButton(props: {
  media: Media;
  disabled: boolean;
  imageState: IMAGE_STATE;
  text: string;
  sx?: SxProps<Theme>;
}): JSX.Element {
  const { enqueueSnackbar } = useSnackbar();
  const { media, imageState, text, ...rest } = props;
  const { logUsage } = useApi();
  const { sessionId, sessionDetails, setSessionDetailsModal } =
    useSessionDetails();
  const { mutate: logUsageMutation } = useMutation("logUsage", logUsage);

  function onCopy(url: string, success: boolean) {
    if (
      sessionDetails.username === undefined ||
      sessionDetails.email === undefined
    ) {
      setSessionDetailsModal({ open: true, media });
    } else {
      logUsageMutation({
        sessionId,
        media,
        sessionDetails,
      });
    }

    if (!success) {
      enqueueSnackbar(
        "Could not attach URL to clipboard, copy URL manually: " + url,
        {
          variant: "warning",
          autoHideDuration: 5000,
        }
      );
      return false;
    } else {
      enqueueSnackbar("The link has been copied to your clipboard.", {
        variant: "success",
      });
    }
  }

  return media.mimetype.classification === MimeTypeClassifications.Image ? (
    <CopyToClipboard text={text} onCopy={onCopy}>
      <Tooltip title="Copy link">
        <span>
          <IconButton {...rest}>
            <ContentCopyIcon />
          </IconButton>
        </span>
      </Tooltip>
    </CopyToClipboard>
  ) : (
    <CopyToClipboard text={text} onCopy={onCopy}>
      <Tooltip title="Copy link">
        <span>
          <IconButton {...rest}>
            <ContentCopyIcon />
          </IconButton>
        </span>
      </Tooltip>
    </CopyToClipboard>
  );
}
